export const build = { date:"2026-02-02.1748", stage:"alpha" }
